// import p5 from "p5";
import { TWO_PI, PHI, SQR_2, GA, SGR } from "./local_mods/math_constants.js";
import {
  frand_rng,
  arr_pick,
  fib_num,
  render_dims,
  fx_shuffle_arr,
  calculateAspectRatioFit,
  bias_arr_pick,
  lerp,
} from "./local_mods/util.js";

const init_clock = function (clk_props, scene) {
  const clk = {};
  clk.active = true;
  clk.prev_ready = false;
  clk.pos = {};
  clk.pos.curr = { x: TWO_PI * frand_rng(), y: 0 };
  clk.pos.targ = { x: clk_props.pos.x, y: clk_props.pos.y };

  clk.rot = {
    orig: 0,
    curr: fxrand() * TWO_PI * scene.i_OPR * arr_pick([-1, 1]),
    targ: 0,
  };
  clk.rot_anim_fact = clk_props.rot_anim_fact;
  clk.dims = {};
  clk.dims.norm = {};
  clk.dims.norm.face = {
    radius: clk_props.clk_face_radius,
  };
  clk.dims.norm.face.w = clk.dims.norm.face.radius * 2;
  clk.dims.norm.face.h = clk.dims.norm.face.w;

  const render = function (curr_dims, pg, face_img) {
    if (!clk.active) return;
    const clk_face_act_x = clk.pos.curr.x * curr_dims.x;
    const clk_face_act_y = clk.pos.curr.y * curr_dims.y;
    const clk_face_act_w = clk.dims.norm.face.radius * curr_dims.min_dim;
    const clk_face_act_h = clk.dims.norm.face.radius * curr_dims.min_dim;

    pg.push();
    pg.translate(clk_face_act_x, clk_face_act_y);

    if (scene.ellipse_on) {
      pg.ellipse(
        0,
        0,
        clk_face_act_w / scene.OPR ** 2,
        clk_face_act_h / scene.OPR ** 2
      );
    }
    pg.rotate(clk.rot.curr);
    pg.image(face_img, 0, 0, clk_face_act_w, clk_face_act_h);
    pg.pop();
  };

  const update = function (p55, pg) {
    if (scene.interactivity_is) {
      let mx_on_canv_is = false;
      // the added 10px is for a little border to help with resetting back to orig rot
      if (
        p55.mouseX > 10 &&
        p55.mouseX < pg.width - 10 &&
        p55.mouseY > 10 &&
        p55.mouseY < pg.height - 10
      ) {
        mx_on_canv_is = true;
      }
      let curr_rot = p55.map(p55.mouseX, pg.width, 0, 0, TWO_PI);
      if (mx_on_canv_is) {
        clk.rot.targ = clk.rot.orig / 2 + clk.rot.orig + curr_rot;
      } else {
        clk.rot.targ = clk.rot.orig;
      }
    }

    clk.pos.curr = clk.pos.targ;

    if (Math.abs(clk.rot.curr - clk.rot.targ) > 0.09) {
      clk.rot.curr = lerp(
        clk.rot.curr,
        clk.rot.targ,
        scene.i_OPR ** clk.rot_anim_fact
      );
    } else {
      if (!scene.preview_is_done) {
        clk.prev_ready = true;
      }
    }
  };
  return { clk, update, render };
};

export { init_clock };
